/* eslint-disable import/no-anonymous-default-export */
import request, { AxiosResponse } from "axios";
import { kore_url } from "./index";
import { EventInterface } from "context/initialState/Encounter";
import axios from "axios";
import saveAs from "file-saver";

export default {
  getList: (
    token: string,
    filter?: string,
    param?: string,
    memberId?: string
  ) => {
    const queries = () => {
      return filter ? `?filter=${filter}` : "";
    };
    const paginationParameters = () => {
      let paginationQuery = "";
      if (!filter) {
        paginationQuery = `?${param ? param : ""}`;
      } else if (filter && param) {
        paginationQuery = `&${param ? param : ""}`;
      }
      return paginationQuery;
    };
    const config = {
      method: "GET",
      url: memberId
        ? `${kore_url}/api/v4/encounters/member/${memberId}${queries()}${paginationParameters()}`
        : `${kore_url}/api/v4/encounters${queries()}${paginationParameters()}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };
    return request(config)
      .then((encounters: AxiosResponse) => {
        return encounters.data;
      })
      .catch((encounterErr) => {
        throw encounterErr;
      });
  },
  getByMember: (
    token: string,
    memberId: string,
    filter?: string,
    param?: string
  ) => {
    const queries = () => {
      return filter ? `?filter=${filter}` : "";
    };
    const paginationParameters = () => {
      let paginationQuery = "";
      if (!filter) {
        paginationQuery = `?${param ? param : ""}`;
      } else if (filter && param) {
        paginationQuery = `&${param ? param : ""}`;
      }
      return paginationQuery;
    };
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/encounters/member/${memberId}${queries()}${paginationParameters()}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };
    return request(config)
      .then((encounters: AxiosResponse) => {
        return encounters.data.items;
      })
      .catch((encounterErr) => {
        throw encounterErr;
      });
  },
  // TODO: combine these two "Export" functions into one:
  getCSV: (
    token: string,
    memberId: string,
    filter?: string,
    userEmail?: string
  ) => {
    const queries = () => {
      return filter ? `?filter=${filter}` : "";
    };
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/encounters/member/${memberId}${queries()}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };
    return request(config)
      .then((newEncounter: AxiosResponse) => {
        return newEncounter.data;
      })
      .catch((encounterErr) => {
        throw encounterErr;
      });
  },
  getExportPDF: (
    token: string,
    memberId: string,
    fileName: string,
    filter?: string,
    userEmail?: string
  ) => {
    const queries = () => {
      return filter ? `?filter=${filter}` : "";
    };
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/encounters/member/${memberId}${queries()}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };

    axios({
      url: config.url,
      headers: config.headers,
      method: "GET",
      responseType: "blob" // Important: This tells axios to expect binary data
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        saveAs(blob, `${fileName}.pdf`);
      })
      .catch((error) => {
        // Handle error if necessary
        console.error("Error while downloading PDF:", error);
      });
  },
  getSingle: (encounterID: string) => {
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/encounters/${encounterID}`,
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
    return request(config)
      .then((encounter: AxiosResponse) => {
        return encounter;
      })
      .catch((encounterErr) => {
        throw encounterErr;
      });
  },
  // not hooked up yet on back end
  getForSingleMember: (token: string, memberId: string) => {
    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/encounters/${memberId}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };
    return request(config)
      .then((encounter: AxiosResponse) => {
        return encounter;
      })
      .catch((encounterErr) => {
        throw encounterErr;
      });
  },
  add: (token: string, encounter: EventInterface) => {
    const config = {
      method: "POST",
      url: `${kore_url}/api/v4/encounters`,
      data: encounter,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };
    return request(config)
      .then((newEncounter: AxiosResponse) => {
        return newEncounter;
      })
      .catch((encounterErr) => {
        throw encounterErr;
      });
  },
  addKeepalive: (token: string, encounter: EventInterface) => {
    return fetch(`${kore_url}/api/v4/encounters`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(encounter),
      keepalive: true
    });
  }
};
